import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Es seguro comprar por internet?',
  answer: 'Sí, absolutamente. Usamos pasarelas de pago protegidas con encriptación bancaria de nivel militar. Su información financiera nunca se guarda en nuestros servidores y está 100% segura.'
}, {
  question: '¿Qué pasa si no tengo computadora?',
  answer: 'No hay problema. Puede leer la guía perfectamente desde su teléfono celular o tableta. También está diseñada para que pueda imprimirla fácilmente si prefiere tenerla en papel y llevarla a su cita.'
}, {
  question: '¿Funciona si estoy divorciada hace años?',
  answer: 'Si su matrimonio duró más de 10 años y usted no se ha vuelto a casar, lo más probable es que sí tenga derecho a reclamar beneficios basados en el historial de su ex-esposo. En la guía le explicamos exactamente cómo confirmarlo y cómo hacerlo sin que él se entere.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-[#FDF8F0]" data-id="element-30">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="text-center mb-12" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-4" data-id="element-33">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-gray-600" data-id="element-34">
            Resolvemos sus dudas para que tome la decisión con total
            tranquilidad.
          </p>
        </div>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-36">
              <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A55A]" aria-expanded={openIndex === index} data-id="element-37">
                <span className="text-lg md:text-xl font-bold text-[#1B2A4A] pr-4" data-id="element-38">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="text-[#C5A55A] shrink-0 bg-[#FDF8F0] p-1 rounded-full" data-id="element-39">
                  <ChevronDown className="w-6 h-6" data-id="element-40" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-41">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-42">
                    <div className="px-6 pb-6 text-gray-700 text-lg border-t border-gray-50 pt-4" data-id="element-43">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}